export { L as LitElement, c as customElement, h as html, p as property } from './common/lit-element-12b13933.js';
